import React, { FC } from "react";
import Image from "next/image";

type SVGComponent = {
  src: string;
  twClasses?: string;
  alt: string;
  width?: number;
  height?: number;
};

const SVG: FC<SVGComponent> = ({ src, twClasses, alt, width, height }) => {
  return (
    <Image
      src={src}
      alt={alt}
      width={width || 20}
      height={height || 20}
      className={twClasses}
      quality={100}
    />
  );
};

export default SVG;
